import React from 'react';
import TrackVisibility from 'react-on-screen';
import Grid from '../Grid';
import { Title, List, GraphicWrapper, AuthenticateStyled, VideoWrapper } from './styled';

const Authenticate = () => {
  return (
    <AuthenticateStyled>
      <Grid>
        <Title>
          Authenticate users across all of your applications with your own custom, secure, and
          standards-based unified login.
        </Title>
        <List>
          <li>Universal login orchestrates single sign-on (SSO) between multiple apps.</li>
          <li>
            If the user has already signed on to one app, the login page will not be shown again and
            the user will be logged in via SSO.
          </li>
        </List>
        <GraphicWrapper>
          <img
            className="mobile"
            src="https://cdn.auth0.com/website/universal-login/ul-sso-diagram-mobile.png"
            alt=""
          />
          <TrackVisibility once partialVisibility>
            {({ isVisible }) =>
              isVisible ? (
                <VideoWrapper>
                  <video
                    muted={'true'}
                    autoPlay={'true'}
                    src="https://videos.ctfassets.net/2ntc334xpx65/67t8nyR02cUssAmCmsaiE6/4abf027ac21be3f56b0c16854b5bcd5e/sso_new_diagram_video.mp4"
                  />
                </VideoWrapper>
              ) : (
                <VideoWrapper />
              )
            }
          </TrackVisibility>
        </GraphicWrapper>
      </Grid>
    </AuthenticateStyled>
  );
};

export default Authenticate;



// WEBPACK FOOTER //
// ./src/pages/universal-login/components/Authenticate/Authenticate.js